export default __webpack_public_path__ + "assets/search.827835b5b1d24dc78246c78c0bc3697f.png";